<div class="pay-confirmation text-center"> 
    <div class="msg">
        <span class="check-wrap">
            <img src="assets/images/tick.png" alt="checked">
        </span>
        <h3>
            <span>Thank You!</span>
            You've created your Team. 
            <br>
            <!-- Please check your email (inbox / spam) for instructions to download and activate the app.  -->
        </h3>
        <!-- <h2 class="colorTheme ">
            One last step!
        </h2> -->
        <!-- <p class="colorTheme ">
            Please check your email for directions to login to your vendor portal.
        </p> -->
        <!-- <div class="subs-apps">
            <a href="https://apps.apple.com/app/id1558197173" target="_blank">
                <img src="assets/images/icon/apple-app.png" alt="mylifewell">
            </a>
            <a href="https://play.google.com/store/apps/details?id=digifit.android.virtuagym.pro.mylifewell&hl=en&gl=US" target="_blank">
                <img src="assets/images/icon/google-app.png" alt="mylifewell">
            </a>
        </div> -->
        <!-- <button *ngIf="" class="btn continue-shooping" [routerLink]="['/']" >
            Explore More
        </button> -->
    </div>
  </div>

